import { z } from "zod";
/**
 * Actor fields for listing/detail responses — WHO created/updated a row.
 * Resolved by joining onshelf.users on created_by / updated_by. Name is the
 * user's full_name (fallback email); email powers a tooltip. All nullable:
 * historical rows created before audit columns existed carry no actor.
 *
 * Spread into an entity's info schema with `.extend(auditActorFields)`.
 */
export const auditActorFields = {
    createdByName: z.string().nullable(),
    createdByEmail: z.string().nullable(),
    updatedByName: z.string().nullable(),
    updatedByEmail: z.string().nullable(),
};
/** Created-only variant for write-once entities (e.g. api keys, captures). */
export const createdByActorFields = {
    createdByName: z.string().nullable(),
    createdByEmail: z.string().nullable(),
};
//# sourceMappingURL=audit.js.map